export default __webpack_public_path__ + "static/media/20210227_101117.9005ad3a.jpg";